module.exports = __webpack_public_path__ + "public/img/back.890d3cdb.png";